import React from 'react';
import SwipeableViews from 'react-swipeable-views';
import styled from 'styled-components';
import { base64ToBinary } from '../../utils/helpers';

import PdfView from '../PdfView';

const Slide = styled.div`
  height: ${(p) => p.h}px;
  max-width: ${(p) => p.w * 0.95}px;
  overflow: auto;
  margin: 0 auto;
`;


function ContractViewer({ width, height, contracts, setView }) {

  const pdf = base64ToBinary(contracts.dataUrl);

  return (
    <SwipeableViews enableMouseEvents>
      <Slide w={width} h={height}>
        <PdfView pdf={pdf} setView={setView} />
      </Slide>
    </SwipeableViews>
  );
}

export default ContractViewer;
